export const SET_TYPE_HEADER = "setTypeHeader";